import React from 'react';
import type { ReactElement } from 'react';
import 'twin.macro';

interface IconCardProps {
  icon: ReactElement;
}

const IconCard: React.FC<IconCardProps> = ({ icon, children }) => (
  <div tw="flex flex-col">
    <div tw="rounded-t-xl text-white bg-blue flex justify-center py-2 px-3">{icon}</div>
    <div tw="rounded-b-xl text-gray-800 bg-gray-100 py-2 px-3">{children}</div>
  </div>
);

export default IconCard;
